import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import {
	invalidateAllContactAutomationsQueries,
	recheckContactAutomationsAfterQueuedStart,
} from './queries/useContactAutomationsQuery';

export function useStartAutomationContactMutation({
	impersonationContext,
	onSuccess,
	onError,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
}) {
	const userSession = useUserSession();

	return useMutation({
		mutationKey: ['startAutomationContact'],
		onSuccess: () => {
			invalidateAllContactAutomationsQueries();
			// The API queues creation rather than doing it inline, so the invalidation above races
			// the job that creates the automation.
			recheckContactAutomationsAfterQueuedStart();
			onSuccess?.();
		},
		onError,
		mutationFn: ({
			id,
			createAutomationRequest,
		}: {
			id: string;
			createAutomationRequest: Api.ICreateAutomationRequest;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IOperationResultNoValue>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `Automation/${id}/Contact`,
				}),
				'POST',
				createAutomationRequest
			);
		},
	});
}
